/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Adjusted_BadgeInputs */

const en_us2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusted for today`)
};

const pt_br2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustado para hoje`)
};

const es_419_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustado para hoy`)
};

const pt_pt2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustado para hoje`)
};

const fr_fr2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusté pour aujourd'hui`)
};

const de_de2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für heute angepasst`)
};

const it_it2_workout_adjusted_badge = /** @type {(inputs: Workout_Adjusted_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adattato per oggi`)
};

/**
* | output |
* | --- |
* | "Adjusted for today" |
*
* @param {Workout_Adjusted_BadgeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_adjusted_badge = /** @type {((inputs?: Workout_Adjusted_BadgeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Adjusted_BadgeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_adjusted_badge(inputs)
	if (locale === "es-419") return es_419_workout_adjusted_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_adjusted_badge(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_adjusted_badge(inputs)
	if (locale === "de-DE") return de_de2_workout_adjusted_badge(inputs)
	if (locale === "it-IT") return it_it2_workout_adjusted_badge(inputs)
	return en_us2_workout_adjusted_badge(inputs)
});
export { workout_adjusted_badge as "workout.adjusted_badge" }